import { Injectable } from '@angular/core';
import { Command } from '../command/command';
import { CommandHandler } from '../command/command-handler';
import { State } from '../state';
import { AppState } from '../state.module';

import {
  AddCurrentWizzardStep,
  AddInitInfoCommand,
  AddPhoneInfoCommand,
  AddFinancingCustomerTypeCommand,
  AddFinancingCustomerIdCommand,
  AddFinancingPaymentIdCommand,
  AddSaleIdCommand,
  AddTotalSaleCommand,
} from './financing-commands';

@Injectable()
export class FinancingCommandHandlerService implements CommandHandler {

  handle(state: State, command: Command): State {
    const appState = (state as AppState);

    switch (command.name) {
      case 'add_current_wizzard_step_financing':
        const addCurrentWizzardStep = (command as AddCurrentWizzardStep);
        return appState.financing.addCurrentWizzardStep(addCurrentWizzardStep.step);

      case 'add_sale_id':
        const addSaleIdCommand = (command as AddSaleIdCommand);
        return appState.financing.addSaleId(addSaleIdCommand.saleId);

      case 'add_init_info_financing':
        const addInitInfoCommand = (command as AddInitInfoCommand);
        return appState.financing.addInitInfo(addInitInfoCommand.brand, addInitInfoCommand.model, addInitInfoCommand.purchasePhoneAmount);

      case 'add_phone_info_financing':
        const addPhoneInfoCommand = (command as AddPhoneInfoCommand);
        return appState.financing.addPhoneInfo(addPhoneInfoCommand.imei, addPhoneInfoCommand.imgReceiptUrl, addPhoneInfoCommand.note, addPhoneInfoCommand.purchaseDate);

      case 'add_customer_type_financing':
        const addFinancingCustomerTypeCommand = (command as AddFinancingCustomerTypeCommand);
        return appState.financing.addFinancingCustomerType(addFinancingCustomerTypeCommand.type);
      case 'add_customer_id_financing':
        const addFinancingCustomerIdCommand = (command as AddFinancingCustomerIdCommand);
        return appState.financing.addFinancingCustomerId(addFinancingCustomerIdCommand.id);
      case 'add_payment_id_financing':
        const addFinancingPaymentIdCommand = (command as AddFinancingPaymentIdCommand);
        return appState.financing.AddFinancingPaymentId(addFinancingPaymentIdCommand.id);
        case 'add_total_sale':
          const addTotalSaleCommand = (command as AddTotalSaleCommand);
          return appState.financing.AddFinancingTotalSale(addTotalSaleCommand.totalSale);
    }

    throw new Error(`FinancingCommandHandlerService cannot handle command ${command.name}".`);
  }
}



// WEBPACK FOOTER //
// ./src/app/state/financing/financing-command-handler.service.ts